import PropTypes from 'prop-types';
import { Form, Button, Card, Row, Col, ProgressBar } from 'react-bootstrap';

async function hogaresenPobrezaExtrema() {
    // Lógica para descargar el listado de hogares en pobreza extrema
    console.log("Descargando listado de hogares en pobreza extrema...");
}

async function hogaresenPobreza() {
    // Lógica para descargar el listado de hogares en pobreza
    console.log("Descargando listado de hogares en pobreza...");
}

async function hogaresPorEncimadePobreza() {
    // Lógica para descargar el listado de hogares por encima de la línea de pobreza
    console.log("Descargando listado de hogares por encima de la línea de pobreza...");
}

async function hogaresSinCalculo() {
    // Lógica para descargar el listado de hogares sin cálculo de pobreza
    console.log("Descargando listado de hogares sin cálculo de pobreza...");
}


async function verTipoActividad() {
    // Lógica para mostrar el tipo de actividad de la población en edad de trabajar
    console.log("Mostrando tipo de actividad de la población en edad de trabajar...");
}

async function personasTrabajando() {
    // Lógica para descargar el listado de personas trabajando
    console.log("Descargando listado de personas trabajando...");
}

async function personasNoTrabajando() {
    // Lógica para descargar el listado de personas no trabajando
    console.log("Descargando listado de personas no trabajando...");
}

async function verEstudiando() {
    // Lógica para mostrar el listado de personas estudiando
    console.log("Mostrando listado de personas estudiando...");
}

async function verOficiosHogar() {
    // Lógica para mostrar el listado de personas con oficios del hogar
    console.log("Mostrando listado de personas con oficios del hogar...");
}

async function verIncapacitados() {
    // Lógica para mostrar el listado de personas incapacitados
    console.log("Mostrando listado de personas incapacitados...");
}

async function verOtraActividad() {
    // Lógica para mostrar el listado de personas con otra actividad
    console.log("Mostrando listado de personas con otra actividad...");
}

async function arrsindato() {
    // Lógica para descargar el listado de personas sin dato de actividad
    console.log("Descargando listado de personas sin dato de actividad...");
}

function ReporteGeneracionIngresos({ datosGeneracionIngresos }) {
    return (
        <Card>
            <Card.Header>
                <Card.Title>
                    <h3>Derecho a la Generacion de Ingresos</h3>
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="row">
                    <div className="col-md-8">
                        <div className="box">
                            <div className="box-header">
                                
                            </div>
                            <div className="box-body no-padding">
                                <table className="table table-condensed">
                                    <thead>
                                        <tr>
                                            <th style={{width: "60%"}}>POBREZA MONETARIA</th>
                                            <th className="thdcenter" style={{width: "20%"}}>Catidad</th>
                                            <th className="thdcenter" style={{width: "20%"}}>Porcentaje</th>
                                        </tr>
                                        <tr>
                                            <th style={{backgroundColor: "#F0F1EF"}}>Total hogares</th>
                                            <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="tdtFamVUR">{datosGeneracionIngresos.tdtFamVUR}</span></th>
                                            <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="tdporctFamVUR" className="badge bg-blue">{datosGeneracionIngresos.tdporctFamVUR}</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td><Button style={{color: "red", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={hogaresenPobrezaExtrema}>Hogares en Pobreza Extrema </Button></td>
                                        <td className="thdcenter"><span id="tdtFamPobrezaExtrema">{datosGeneracionIngresos.tdtFamPobrezaExtrema}</span></td>
                                        <td className="thdcenter"><span id="tdporctFamPobrezaExtrema" className="badge bg-red">{datosGeneracionIngresos.tdporctFamPobrezaExtrema}</span></td>
                                    </tr>
                                    <tr>
                                        <td><Button style={{color: "red", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={hogaresenPobreza}>Hogares en Pobreza </Button></td>
                                        <td className="thdcenter"><span id="tdtFamPobreza">{datosGeneracionIngresos.tdtFamPobreza}</span></td>
                                        <td className="thdcenter"><span id="tdporctFamPobreza" className="badge bg-red">{datosGeneracionIngresos.tdporctFamPobreza}</span></td>
                                    </tr>
                                    <tr>
                                        <td><Button style={{color: "green", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={hogaresPorEncimadePobreza}>Hogares por encima de la Línea de Pobreza</Button></td>
                                        <td className="thdcenter"><span id="tdtFamEncimaLPobreza">{datosGeneracionIngresos.tdtFamEncimaLPobreza}</span></td>
                                        <td className="thdcenter"><span id="tdporctFamEncimaLPobreza" className="badge bg-green">{datosGeneracionIngresos.tdporctFamEncimaLPobreza}</span></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <Button style={{color: "red", background: "none", border: "none", padding: 0}} onClick={hogaresSinCalculo}>
                                    <span id="tdtotrasFamilias">{datosGeneracionIngresos.tdtotrasFamilias}</span>
                                </Button>
                            </div>
                            <hr/>
                            <br/>
                            <div className="box-body no-padding">
                                <table className="table table-condensed">
                                <tbody>
                                <tr>
                                    <th style={{width: "60%"}} colSpan="5">POBLACIÓN EN EDAD DE TRABAJAR (Entre 18 y 50 años de edad)</th>
                                </tr>
                                <tr>
                                    <td><Button style={{color: "black", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={() => {verTipoActividad()}}>Tipo Actividad</Button></td>
                                    <td className="thdcenter" colSpan="2"><span id="">Población en edad de trabajar entre 18 y 28 años de edad</span></td>
                                    <td className="thdcenter" colSpan="2"><span id="">Población en edad de trabajar entre 29 y 50 años de edad</span></td>
                                </tr>
                                <tr>
                                    <th style={{backgroundColor: "#F0F1EF"}}>Total Personas</th>
                                    <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="txtp18a28total">{datosGeneracionIngresos.txtp18a28total}</span></th>
                                    <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="txtporcp18a28total" className="badge bg-blue">{datosGeneracionIngresos.txtporcp18a28total}</span></th>
                                    <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="txtp29a50total">{datosGeneracionIngresos.txtp29a50total}</span></th>
                                    <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="txtporcp29a50total" className="badge bg-blue">{datosGeneracionIngresos.txtporcp29a50total}</span></th>
                                </tr>
                                <tr>
                                    <td>1. Trabajando, <Button style={{color: "green", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={personasTrabajando}>descargar Listado</Button></td>
                                    <td className="thdcenter"><span id="txtp18a28trabajando">{datosGeneracionIngresos.txtp18a28trabajando}</span></td>
                                    <td className="thdcenter"><span id="txtporcp18a28trabajando" className="badge bg-green">{datosGeneracionIngresos.txtporcp18a28trabajando}</span></td>
                                    <td className="thdcenter"><span id="txtp29a50trabajando">{datosGeneracionIngresos.txtp29a50trabajando}</span></td>
                                    <td className="thdcenter"><span id="txtporcp29a50trabajando" className="badge bg-green">{datosGeneracionIngresos.txtporcp29a50trabajando}</span></td>
                                </tr>
                                <tr>
                                    <td>2. Buscando Trabajo</td>
                                    <td className="thdcenter"><span id="txtp18a28busctrabajo">{datosGeneracionIngresos.txtp18a28busctrabajo}</span></td>
                                    <td className="thdcenter"><span id="txtporcp18a28busctrabajo" className="badge bg-green">{datosGeneracionIngresos.txtporcp18a28busctrabajo}</span></td>
                                    <td className="thdcenter"><span id="txtp29a50busctrabajo">{datosGeneracionIngresos.txtp29a50busctrabajo}</span></td>
                                    <td className="thdcenter"><span id="txtporcp29a50busctrabajo" className="badge bg-green">{datosGeneracionIngresos.txtporcp29a50busctrabajo}</span></td>
                                </tr>
                                <tr>
                                    <td><Button style={{color: "black", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={() => {verEstudiando()}}>3. Estudiando </Button></td>
                                    <td className="thdcenter"><span id="txtp18a28estudiando">{datosGeneracionIngresos.txtp18a28estudiando}</span></td>
                                    <td className="thdcenter"><span id="txtporcp18a28estudiando" className="badge bg-green">{datosGeneracionIngresos.txtporcp18a28estudiando}</span></td>
                                    <td className="thdcenter"><span id="txtp29a50estudiando">{datosGeneracionIngresos.txtp29a50estudiando}</span></td>
                                    <td className="thdcenter"><span id="txtporcp29a50estudiando" className="badge bg-green">{datosGeneracionIngresos.txtporcp29a50estudiando}</span></td>
                                </tr>
                                <tr>
                                    <td><Button style={{color: "black", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={() => {verOficiosHogar()}}>4. Oficios del Hogar </Button></td>
                                    <td className="thdcenter"><span id="txtp18a28oficioshogar">{datosGeneracionIngresos.txtp18a28oficioshogar}</span></td>
                                    <td className="thdcenter"><span id="txtporcp18a28oficioshogar" className="badge bg-green">{datosGeneracionIngresos.txtporcp18a28oficioshogar}</span></td>
                                    <td className="thdcenter"><span id="txtp29a50oficioshogar">{datosGeneracionIngresos.txtp29a50oficioshogar}</span></td>
                                    <td className="thdcenter"><span id="txtporcp29a50oficioshogar" className="badge bg-green">{datosGeneracionIngresos.txtporcp29a50oficioshogar}</span></td>
                                </tr>
                                <tr>
                                    <td><Button style={{color: "black", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={() => {verIncapacitados()}}>5. Incapacitados </Button></td>
                                    <td className="thdcenter"><span id="txtp18a28incapacitado">{datosGeneracionIngresos.txtp18a28incapacitado}</span></td>
                                    <td className="thdcenter"><span id="txtporcp18a28incapacitado" className="badge bg-green">{datosGeneracionIngresos.txtporcp18a28incapacitado}</span></td>
                                    <td className="thdcenter"><span id="txtp29a50incapacitado">{datosGeneracionIngresos.txtp29a50incapacitado}</span></td>
                                    <td className="thdcenter"><span id="txtporcp29a50incapacitado" className="badge bg-green">{datosGeneracionIngresos.txtporcp29a50incapacitado}</span></td>
                                </tr>
                                <tr>
                                    <td><Button style={{color: "black", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={() => {verOtraActividad()}}>6. Otra actividad </Button></td>
                                    <td className="thdcenter"><span id="txtp18a28otro">{datosGeneracionIngresos.txtp18a28otro}</span></td>
                                    <td className="thdcenter"><span id="txtporcp18a28otro" className="badge bg-green">{datosGeneracionIngresos.txtporcp18a28otro}</span></td>
                                    <td className="thdcenter"><span id="txtp29a50otro">{datosGeneracionIngresos.txtp29a50otro}</span></td>
                                    <td className="thdcenter"><span id="txtporcp29a50otro" className="badge bg-green">{datosGeneracionIngresos.txtporcp29a50otro}</span></td>
                                </tr>
                                <tr>
                                    <td colSpan="5">No Trabajando (items 2, 3, 4, 5 y 6), <Button style={{color: "red", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={personasNoTrabajando}>descargar listado</Button></td>
                                </tr>
                                </tbody></table>
                            </div>
                            <Button style={{color: "red", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={arrsindato}>descargar listado sin dato</Button>
                            <hr/>
                            <br/>
                            <div className="box-body no-padding">
                                <table className="table table-condensed">
                                <tbody>
                                <tr>
                                    <th style={{width: "60%"}}>INGRESOS SEGÚN FUENTE</th>
                                    <th className="thdcenter" style={{width: "20%"}}>Catidad</th>
                                    <th className="thdcenter" style={{width: "20%"}}>Porcentaje</th>
                                </tr>
                                <tr>
                                    <th style={{backgroundColor: "#F0F1EF"}}>Total hogares</th>
                                    <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="txttotalsubsidios">{datosGeneracionIngresos.txttotalsubsidios}</span></th>
                                    <th style={{backgroundColor: "#F0F1EF"}} className="thdcenter"><span id="txtporctotalsubsidios" className="badge bg-blue">{datosGeneracionIngresos.txtporctotalsubsidios}</span></th>
                                </tr>
                                <tr>
                                    <td><Button style={{color: "black", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={() => {verIngresosFuerzaTrabajo()}}>Ingresos fuerza de trabajo </Button></td>
                                    <td className="thdcenter"><span id="txtsumtotalingFTrabajo">{datosGeneracionIngresos.txtsumtotalingFTrabajo}</span></td>
                                    <td className="thdcenter"><span id="txtporcsumtotalingFTrabajo" className="badge bg-green">{datosGeneracionIngresos.txtporcsumtotalingFTrabajo}</span></td>
                                </tr>
                                <tr>
                                    <td><Button style={{color: "black", cursor: "pointer", background: "none", border: "none", padding: 0}} onClick={() => {verIngresosSubsidios()}}>Ingresos subsidios </Button></td>
                                    <td className="thdcenter"><span id="txtsumtotalingSubsidios">{datosGeneracionIngresos.txtsumtotalingSubsidios}</span></td>
                                    <td className="thdcenter"><span id="txtporcsumtotalingSubsidios" className="badge bg-green">{datosGeneracionIngresos.txtporcsumtotalingSubsidios}</span></td>
                                </tr>
                                </tbody></table>
                            </div>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

ReporteGeneracionIngresos.propTypes = {
    datosGeneracionIngresos: PropTypes.object.isRequired,
};

export default ReporteGeneracionIngresos;